import Component  from '../colorz/Component';

import creator    from '../colorz/utils/creator';
import device     from '../colorz/utils/device';
import FadeIn     from './animations/FadeIn';
import CollectionsClassicSlider     from './CollectionsClassicSlider';

module.exports = class Loadmore extends Component {
  onInit( el, args) {
    // Initializations
    this.el = el;
  }

  onReady() {
    jQuery(document).ready(function(){
      jQuery(window).scroll(function(){
        var win = window.pageYOffset || document.documentElement.scrollTop;
        var instagram = document.querySelector('.strate-instagram').offsetTop;
        var offset = instagram - 800;

        if ( win >= offset ) {
          var $more     = jQuery('.button-loadmore');
          var more      = jQuery('.button-loadmore')[0];
          var nextPage  = parseInt( more.getAttribute('data-next-page') );
          var maxPage   = parseInt( more.getAttribute('data-max-page') );
          var url       = more.getAttribute('data-href');
          var isLoaded = false;

          console.log( nextPage, maxPage )

          if ( nextPage <= maxPage &&  !jQuery('body').hasClass('isLoading') ) {
            jQuery.ajax({
                url: url,
                type: 'GET',
                beforeSend: function(){
                  jQuery('.icon').addClass('is-visible');
                  jQuery('body').addClass('isLoading');
                },
                success: function(data){
                  jQuery('.icon').removeClass('is-visible');
                  var item = jQuery(data).find('.js-item');
                  var LoadMore = jQuery(data).find('.button-loadmore');

                  if (jQuery(item).length > 0) {
                      jQuery(item).each(function(){
                        jQuery('.js-list').append(jQuery(this));
                        let fadedIns = creator('.js-fade-in', FadeIn, '', this);
                        window.fadeIn = window.fadeIn.concat( fadedIns );
                        let sliders = creator('.js-slider-collections', CollectionsClassicSlider, '', this);
                        window.collectionsClassicSlider = window.collectionsClassicSlider.concat( sliders );
                      });
                  }else {
                      jQuery('.js-list').append(jQuery(item));
                  }

                  var parent = $more.parent();
                  jQuery('.button-loadmore').parent().html('');

                  if (nextPage < maxPage) {
                    parent.append(jQuery(LoadMore));
                  }

                  jQuery('body').removeClass('isLoading');
                },
                error: function() {
                  console.log('error');
                }
            });
          }
          return false;
        }
      });
    });
  }
}